import { useEffect, useState } from 'react';
import { Popover } from '../Popover';
import { MdOutlineAdd, MdFilterAltOff, MdOutlineRemove } from 'react-icons/md';

import { FilterRenderMode } from './types';

interface ChicletFilterProps {
  name: string;
  icon?: React.ReactNode;
  filterCount?: number;
  onFilterClick?: () => void;
  onFilterClear?: () => void;
  onRemove?: () => void;
  onTogglePlacement?: () => void;
  isOpen?: boolean;
  renderMode?: FilterRenderMode;
  children: React.ReactNode;
  popoverHeight?: number;
}

export const ChicletFilter = ({
  name,
  icon,
  filterCount = 0,
  onFilterClick,
  onFilterClear,
  onRemove,
  onTogglePlacement,
  isOpen = false,
  renderMode = FilterRenderMode.Chiclet,
  children,
  popoverHeight,
}: ChicletFilterProps) => {
  const [filterOpen, setFilterOpen] = useState(isOpen);
  const handleFilterClick = () => {
    onFilterClick?.();
    setFilterOpen(!filterOpen);
  };
  const handleFilterClear = () => {
    onFilterClear?.();
    setFilterOpen(false);
  };
  useEffect(() => {
    setFilterOpen(isOpen);
  }, [isOpen]);

  if (renderMode === FilterRenderMode.Inline) {
    return (
      <div className="chiclet-filter chiclet-filter--inline">
        <div className="chiclet-filter-content">
          <div className="chiclet-filter-controls">
            <span>
              {icon && <span className="chiclet-filter-icon">{icon}</span>}
              {name}
            </span>
            <div className="chiclet-filter-actions">
              {onTogglePlacement && (
                <button
                  className="button transparent"
                  onClick={onTogglePlacement}
                  title="Add as chiclet"
                >
                  <span className="chiclet-filter-icon">
                    <MdOutlineAdd />
                  </span>
                </button>
              )}
              <button className="button transparent" onClick={onFilterClear} title="Clear filter">
                <span className="chiclet-filter-icon">
                  <MdFilterAltOff />
                </span>
              </button>
            </div>
          </div>
          <div className="chicklet-filter-children">{children}</div>
        </div>
      </div>
    );
  }

  return (
    <Popover
      popoverToggle={
        <button
          className={`button chiclet-filter-toggle${filterCount > 0 ? ' active' : ''}`}
          onClick={handleFilterClick}
        >
          {icon && <span className="chiclet-filter-icon">{icon}</span>}
          {name}
          {filterCount > 0 && <span className="chiclet-filter-count">({filterCount})</span>}
        </button>
      }
      isOpen={filterOpen}
      onClose={() => setFilterOpen(false)}
      className="chiclet-filter"
      height={popoverHeight}
    >
      <div className="chiclet-filter-content">
        <div className="chiclet-filter-controls">
          <span>Filter {name}</span>
          <div className="chiclet-filter-actions">
            {onTogglePlacement && (
              <button
                className="button transparent"
                onClick={onTogglePlacement}
                title="Move to menu"
              >
                <span className="chiclet-filter-icon">
                  <MdOutlineRemove />
                </span>
              </button>
            )}
            <button className="button transparent" onClick={handleFilterClear} title="Clear filter">
              <span className="chiclet-filter-icon">
                <MdFilterAltOff />
              </span>
            </button>
          </div>
        </div>
        <div className="chicklet-filter-children">{children}</div>
      </div>
    </Popover>
  );
};
